export class DataLayerHelper {

    /**
     * @type {string}
     */
    static ADD_TO_CART_EVENT = 'add_to_cart';

    /**
     * @type {string}
     */
    static REMOVE_FROM_CART_EVENT = 'remove_from_cart';

    /**
     * @type {string}
     */
    static ADD_TO_WISH_LIST_EVENT = 'add_to_wishlist';

    /**
     * @type {string}
     */
    static REMOVE_FROM_WISH_LIST_EVENT = 'remove_from_wishlist';

    /**
     * @type {string}
     */
    static ADD_TO_REQUEST_CART_EVENT = 'add_to_request_cart';

    /**
     * @type {string}
     */
    static VIEW_CART_EVENT = 'view_cart';

    /**
     * @type {string}
     */
    static VIEW_ITEM_EVENT = 'view_item';

    /**
     * @type {string}
     */
    static CLICK_WISH_LIST_EVENT = 'click_wishlist';

    /**
     * @type {string}
     */
    static CLICK_REQUEST_LIST_EVENT = 'click_request';

    /**
     * @type {string}
     */
    static CLICK_PROFILE_EVENT = 'click_profile';

    /**
     * @type {string}
     */
    static SEARCH_EVENT = 'search';
    /**
     * @type {string}
     */
    static VIN_SEARCH_EVENT = 'vin_search';

    /**
     * @type {string}
     */
    static APPLY_COUPON_EVENT = 'apply_coupon';

    /**
     * @type {string}
     */
    static BEGIN_CHECKOUT_EVENT = 'begin_checkout';

    /**
     * @type {string}
     */
    static CHECKOUT_STEP_1_EVENT = 'checkout_step_1';

    /**
     * @type {string}
     */
    static CHECKOUT_STEP_2_EVENT = 'checkout_step_2';

    /**
     * @type {string}
     */
    static CHECKOUT_STEP_3_EVENT = 'checkout_step_3';

    /**
     * @type {string}
     */
    static ADD_PAYMENT_INFO = 'add_payment_info';

    /**
     * @type {string}
     */
    static ADD_SHIPPING_INFO = 'add_shipping_info';

    /**
     * @type {string}
     */
    static FORM_ERROR = 'form_error';

    /**
     * @type {string}
     */
    static GLOBAL_ERROR = 'global_error';

    /**
     * @type {string}
     */
    static EDIT_CONFIRM_ADDRESS_EVENT = 'edit_confirm_address';

    /**
     * @type {string}
     */
    static PURCHASE_EVENT = 'purchase';

    /**
     * @type {string}
     */
    static COUNTRY_VALIDATION_EVENT = 'country_validation';

    /**
     * Pushes an event to the data layer
     *
     * @param eventName {string}
     * @param eventCategory {string}
     * @param eventData {Object}
     * @returns {void}
     */
    static pushEvent(
        eventName,
        eventCategory,
        eventData = {}
    ){
        window.dataLayer = window.dataLayer || [];

        let data = {
            event: eventName,
            event_category: eventCategory,
            ...eventData
        }

        if (DataLayerHelper.isEcommerceEvent(eventName)) {
            data = {
                event: eventName,
                ecommerce: eventData
            }
        }

        /**
         * Push against data layer.
         */
        window.dataLayer.push(data);

        // Log the event to the console
        console.log(
            `Data Layer Event send: ${eventName} with category ${eventCategory}`,
            data
        );

        // Store the event in the local storage as it sometimes gets lost when the page is reloaded.

        try {

            localStorage.setItem(
                'dataLayerHistory',
                JSON.stringify(data)
            );

        } catch (error) {

            console.trace(
                'Error saving dataLayerHistory to local storage',
                error
            );
        }
    }

    /**
     * @param eventName {string}
     * @returns {boolean}
     */
    static isEcommerceEvent(eventName) {
        return [
            DataLayerHelper.ADD_TO_CART_EVENT,
            DataLayerHelper.ADD_TO_WISH_LIST_EVENT,
            DataLayerHelper.REMOVE_FROM_WISH_LIST_EVENT,
            DataLayerHelper.ADD_TO_REQUEST_CART_EVENT,
            DataLayerHelper.VIEW_CART_EVENT,
            DataLayerHelper.BEGIN_CHECKOUT_EVENT,
            DataLayerHelper.ADD_SHIPPING_INFO,
            DataLayerHelper.ADD_PAYMENT_INFO,
            DataLayerHelper.VIEW_ITEM_EVENT,
            DataLayerHelper.REMOVE_FROM_CART_EVENT
        ].includes(eventName);
    }
}